module.exports = __webpack_public_path__ + "img/Garmin-connect-logo.54997d95.jpg";